var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPrint = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0636 13.069L20.1061 13.069V11.0583L12.0636 11.0583V13.069Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1061 9.04772L12.0636 9.04772V7.0371L20.1061 7.0371V9.04772Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.122 21.6141C23.9549 21.6141 24.63 20.9389 24.63 20.1061C24.63 19.2733 23.9549 18.5982 23.122 18.5982C22.2892 18.5982 21.6141 19.2733 21.6141 20.1061C21.6141 20.9389 22.2892 21.6141 23.122 21.6141Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1273 3.01587V13.069H25.1327C27.3535 13.069 29.1539 14.8693 29.1539 17.0902V23.122C29.1539 24.2325 28.2537 25.1327 27.1433 25.1327H24.1273V29.1539H8.04241V25.1327H5.02649C3.91605 25.1327 3.01587 24.2325 3.01587 23.122V17.0902C3.01587 14.8693 4.81624 13.069 7.0371 13.069H8.04241V3.01587H24.1273ZM22.1167 15.0796H10.053V5.02649H22.1167V15.0796ZM24.1273 17.0902V15.0796H25.1327C26.2431 15.0796 27.1433 15.9798 27.1433 17.0902V23.122H5.02649L5.02649 17.0902C5.02649 15.9798 5.92667 15.0796 7.0371 15.0796H8.04241V17.0902H24.1273ZM10.053 25.1327H22.1167V27.1433H10.053V25.1327Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPrint);
export default ForwardRef;